<template>

  <div class="home-notes">
    <p>* Click the picture or menu button for details.</p>
  </div>    


  <div class="home-container-1">
    <div class="home-grid-1">
      <div>
        <router-link to="/bibimbap">
          <img class="grid-pics" src="../assets/BibimbapBeefBulgogi.jpg">
        </router-link>
      </div>

      <div class="bibimbap-button">
        <router-link to="/Bibimbap"> 
          <button class="menu-button">Bibimbap</button>
        </router-link>
      </div>
    </div>

    <div class="home-grid-2">
      <div>
        <router-link to="/bulgogi">
          <img class="grid-pics" src="../assets/BulgogiBeef.jpg">
        </router-link>
      </div>

      <div class="bulgogi-button">
        <router-link to="/Bulgogi"> 
          <button class="menu-button">Bulgogi</button>
        </router-link>
      </div>
    </div>

    <div class="home-grid-3">
      <div>
        <router-link to="/kimbap">
          <img class="grid-pics" src="../assets/KimbapClassic.jpg">
        </router-link>
      </div>

      <div class="kimbap-button">
        <router-link to="/Kimbap"> 
          <button class="menu-button">Kimbap</button>
        </router-link>
      </div>
    </div>

    <div class="home-grid-4">
      <div>
        <router-link to="/tempura">
          <img class="grid-pics" src="../assets/TempuraCombo.jpg">
        </router-link>
      </div>

      <div class="tempura-button">
        <router-link to="/Tempura"> 
          <button class="menu-button">Tempura</button>
        </router-link>
      </div>
    </div>

  </div>


  <div class="home-container-2">
    <div class="home-grid-5">
      <div>
        <router-link to="/dumpling">
          <img class="grid-pics" src="../assets/DumplingDeepFried.jpg">
        </router-link>
      </div>

      <div class="dumpling-button">
        <router-link to="/Dumpling"> 
          <button class="menu-button">Dumpling</button>
        </router-link>
      </div>
    </div>

    <div class="home-grid-6">
      <div>
        <router-link to="/friedrice">
          <img class="grid-pics" src="../assets/FriedRiceVeggie.jpg">
        </router-link>
      </div>

      <div class="friedrice-button">
        <router-link to="/FriedRice"> 
          <button class="menu-button">Fried Rice</button>
        </router-link>
      </div>
    </div>

    <div class="home-grid-7">
      <div>
        <router-link to="/combo">
          <img class="grid-pics" src="../assets/ComboKimbapTteokbokki.jpg">
        </router-link>
      </div>

      <div class="combo-button">
        <router-link to="/Combo"> 
          <button class="menu-button">Combo</button>
        </router-link>
      </div>
    </div>

    <div class="home-grid-8">
      <div>
        <router-link to="/noodle">
          <img class="grid-pics" src="../assets/Ramen.jpg">
        </router-link>
      </div>

      <div class="noodle-button">
        <router-link to="/noodle"> 
          <button class="menu-button">Noodle</button>
        </router-link>
      </div>
    </div>    
  </div>


  <div class="home-container-3">
    <div class="home-grid-9">
      <div>
        <router-link to="/jjigae">
          <img class="grid-pics" src="../assets/JjigaeDoenjang.jpg">
        </router-link>
      </div>

      <div class="jjigae-button">
        <router-link to="/Jjigae"> 
          <button class="menu-button">Jjigae</button>
        </router-link>
      </div>
    </div>

    <div class="home-grid-10">
      <div>
        <router-link to="/soup">
          <img class="grid-pics" src="../assets/SoupMussel.jpg">
        </router-link>
      </div>

      <div class="soup-button">
        <router-link to="/soup"> 
          <button class="menu-button">Soup</button>
        </router-link>
      </div>
    </div>

    <div class="home-grid-11">
      <div>        
        <router-link to="/spicybowls">
          <img class="grid-pics" src="../assets/SpicyBowlsKimchiPork.jpg">
        </router-link>
      </div>

      <div class="spicybowls-button">
        <router-link to="/SpicyBowls"> 
          <button class="menu-button">Spicy Bowls</button>
        </router-link>
      </div>
    </div>

    <div class="home-grid-12">
      <div>
        <router-link to="/sidedish">
          <img class="grid-pics" src="../assets/SideDishVeggie.jpg">
        </router-link>
      </div>

      <div class="sidedish-button">
        <router-link to="/SideDish"> 
          <button class="menu-button">Side Dish</button>
        </router-link>
      </div>
    </div>    
  </div>


  <div class="home-container-4">

    <div class="home-grid-13">
      <div>
        <router-link to="/smallplates">
          <img class="grid-pics" src="../assets/DumplingPanFried.jpg">
        </router-link>
      </div>

      <div class="dessert-button">
        <router-link to="/SmallPlates"> 
          <button class="menu-button">Small Plates</button>
        </router-link>
      </div>
    </div>


    <div class="home-grid-14">
      <div>
        <router-link to="/JapchaeTteokbokki">
          <img class="grid-pics" src="../assets/Japchae.jpg">
        </router-link>
      </div>

      <div class="dessert-button">
        <router-link to="/JapchaeTteokbokki"> 
          <button class="menu-button">Japchae&Tteokbokki</button>
        </router-link>
      </div>
    </div>


    <div class="home-grid-15">
      <div>
        <router-link to="/KoreanPancake">
          <img class="grid-pics" src="../assets/DumplingPanFried.jpg">
        </router-link>
      </div>

      <div class="dessert-button">
        <router-link to="/KoreanPancake"> 
          <button class="menu-button">Korean Pancake</button>
        </router-link>
      </div>
    </div>


    <div class="home-grid-16">
      <div>
        <router-link to="/Drinks">
          <img class="grid-pics" src="../assets/DessertCoolish.jpg">
        </router-link>
      </div>

      <div class="dessert-button">
        <router-link to="/Drinks"> 
          <button class="menu-button">Drinks & Desserts</button>
        </router-link>
      </div>
    </div>

  </div>


  <router-view/>

</template>



<script>
  export default {
    name: 'HomeBody'
  }
</script>

  
<style scoped>

/* for desktop */
@media (min-width:701px) { 

  .home-notes {
    text-align: left;
    font-size: 1.3rem;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: 3vw;
    margin-bottom: 3vw;
    margin-left: 1.5vw;
    color: darkblue;
  }

  .home-container-1, .home-container-2, .home-container-3, .home-container-4 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    width: 100%;
    height: 20vw;
    margin-top: 3vw;
    background-color: rgb(250,250,250);
  }    
  
  .grid-pics {
    width: 20vw;
    height: 15vw;
    margin-top: 1vw;
    margin-left: 1.5vw;
  }

  .menu-button {
    cursor: pointer;
    text-align: left;
    color: darkblue;
    background-color: rgb(255,240,133);
    font-size: 1.3rem;
    font-weight: bold;
    border: 1px solid gray;
    line-height: 2.5vw;
    margin-left: 1.5rem;
    justify-content: top left;
  }

 } 



/* for Phone */
@media (max-width:700px) {

  .home-notes {
    text-align: center;
    font-size: 1rem;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: 3vw;
    margin-bottom: 3vw;
    margin-left: 2.5vw;
    color: darkblue;
  }


  .grid-pics {
    width: 10rem;
    height: 7.5rem;
    margin-top: 1rem;
    margin-left: 2rem;
  }

  .menu-button {
    cursor: pointer;
    text-align: center;
    color: darkblue;
    background-color: rgb(255,240,133);
    font-size: 1.3rem;
    font-weight: bold;
    border: 1px solid gray;
    line-height: 1rem;
    justify-content: top left;
    margin-bottom: 1rem;
    margin-left: 1.3rem;
  }

}

</style>